module.exports = __webpack_public_path__ + "static/img/xffsq.a568376.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/xffsq.jpg
// module id = /fQE
// module chunks = 21